import store from 'redux/store';

export const Language = {
	ENG: 'en',
	AR: 'ar',
};

export function getLanguage(): types.redux.settings.language {
	return store.getState().settings.language;
}
